import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import React from "react";
import axios from "axios";
import {
  Box,
  Button,
  Typography,
  Paper,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";

import Nursery from "../Images/Nursery.png";
import PrimaryShool from "../Images/PrimaryShool.png";
import SecondarySchool from "../Images/SecondarySchool.png";
const PrintStudent = () => {
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [studentData, setStudentData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const token = localStorage.getItem("token");
  const [selectedImage, setSelectedImage] = React.useState(Nursery);
  const user = JSON.parse(localStorage.getItem("user"));

  React.useEffect(() => {
    const loadUserData = () => {
      const branchId = user?.branch_id || 2;
      const branchImages = {
        1: Nursery,
        2: PrimaryShool,
        3: SecondarySchool,
      };
      setSelectedImage(branchImages[branchId] || Nursery);
    };

    loadUserData();
  }, [user]);

  const branchTitleMap = {
    1: "باخچەی منداڵانی کلیڤەری ناحکومی",
    2: "ناوەندیی کلیڤەری ناحکومی",
    3: "ئامادەی کلیڤەری ناحکومی",
  };
  const branchTitle =
    branchTitleMap[user?.branch_id] || "قوتابخانەی کلیڤەری بنەڕەتی ناحکومی";
  // Fixed academic year
  const getCurrentAcademicYear = () => {
    const currentYear = new Date().getFullYear();
    return `${currentYear}-${currentYear + 1}`;
  };

  React.useEffect(() => {
    const getStudentData = async () => {
      try {
        const response = await axios.get(
          `https://api.clever-school.com/api/students/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const item = response.data;
        const classModelName = item.class_model?.name
          ? JSON.parse(item.class_model.name)
          : {};
        const sectionName = item.section?.name
          ? JSON.parse(item.section.name)
          : {};

        setStudentData({
          ...item,
          class_model: classModelName[i18n.language] || "",
          section: sectionName[i18n.language] || "",
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    getStudentData();
  }, [id, token, i18n.language]);

  const handlePrint = () => {
    window.print();
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (!studentData) {
    return (
      <Typography variant="h6" align="center" mt={4}>
        {t("studentNotFound")}
      </Typography>
    );
  }

  const totalPaid = studentData.tuition_payments?.reduce(
    (sum, payment) => sum + parseFloat(payment.amount_paid),
    0
  );

  // Calculate remaining amount
  const tuitionFee = studentData.tuitions?.[0]?.final_amount || 0;
  const remainingAmount = parseFloat(tuitionFee) - totalPaid;

  return (
    <Box
      sx={{
        p: 4,
        margin: "0 auto",
        maxWidth: "800px",
        direction: "rtl",
        textAlign: "right",
      }}
    >
      <Box sx={{ mb: 2, display: "flex", justifyContent: "flex-start" }}>
        <Button
          variant="contained"
          startIcon={<PrintIcon />}
          onClick={handlePrint}
          sx={{
            mb: 2,
            backgroundColor: "#1890ff",
            "&:hover": { backgroundColor: "#40a9ff" },
          }}
        >
          {t("print")}
        </Button>
      </Box>

      <div id="delivery-note">
        <Paper
          sx={{
            p: 4,
            mb: 3,
            width: "100%",
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
          elevation={0}
        >
          {/* Header Section */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
              borderBottom: "2px solid #f0f0f0",
              pb: 2,
            }}
          >
            <Box>
              {/* <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "#333" }}
              >
                حکومەتی هەرێمی کوردستان
              </Typography>
              <Typography variant="body1" sx={{ color: "#555" }}>
                بەڕێوەبەرایەتی گشتی پەروەردەی هەولێر
              </Typography> */}
              <Typography variant="body1" sx={{ color: "#555" }}>
                {branchTitle}
              </Typography>
              <Typography variant="body1" sx={{ color: "#555", mb: 1 }}>
                ساڵی خوێندن ( {getCurrentAcademicYear()} )
              </Typography>
            </Box>

            <Box sx={{ width: "100px" }}>
              <img
                src={selectedImage}
                alt="School Logo"
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </Box>
          </Box>

          {/* Receipt Title */}
          <Typography
            variant="h4"
            sx={{
              color: "#d32f2f",
              fontSize: "1.8rem",
              fontWeight: "bold",
              textAlign: "center",
              mb: 4,
            }}
          >
            پسولەی پارە وەرگرتن
          </Typography>

          {/* Student Information */}
          <Box
            sx={{
              mb: 4,
              p: 3,
              backgroundColor: "#f9f9f9",
              borderRadius: "6px",
              border: "1px solid #e0e0e0",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                color: "#333",
                fontWeight: "bold",
                borderBottom: "1px solid #e0e0e0",
                pb: 1,
              }}
            >
              زانیاری قوتابی
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="body1">
                  <span style={{ fontWeight: "bold", color: "#555" }}>
                    ناوی قوتابی:{" "}
                  </span>
                  {studentData.name}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">
                  <span style={{ fontWeight: "bold", color: "#555" }}>
                    ژمارەی مۆبایل:{" "}
                  </span>
                  {studentData.phone_number}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">
                  <span style={{ fontWeight: "bold", color: "#555" }}>
                    پۆل:{" "}
                  </span>
                  {studentData.class_id}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">
                  <span style={{ fontWeight: "bold", color: "#555" }}>
                    هۆبە:{" "}
                  </span>
                  {studentData.section_id}
                </Typography>
              </Grid>
            </Grid>
          </Box>

          {/* Tuition Information */}
          {studentData.tuitions?.length > 0 && (
            <Box
              sx={{
                mb: 4,
                p: 3,
                backgroundColor: "#f9f9f9",
                borderRadius: "6px",
                border: "1px solid #e0e0e0",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  mb: 2,
                  color: "#333",
                  fontWeight: "bold",
                  borderBottom: "1px solid #e0e0e0",
                  pb: 1,
                }}
              >
                زانیاری خوێندن
              </Typography>
              <TableContainer>
                <Table
                  sx={{
                    border: "1px solid #e0e0e0",
                    "& .MuiTableCell-root": {
                      border: "1px solid #e0e0e0",
                      padding: "8px 16px",
                    },
                  }}
                >
                  <TableBody sx={{ textAlign: "right" }}>
                    {studentData.tuitions.map((tuition) => (
                      <React.Fragment key={tuition.id}>
                        <TableRow>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              width: "30%",
                              textAlign: "right",
                            }}
                          >
                            ساڵی ئەکادیمی
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: "center",
                            }}
                          >
                            {tuition.academic_year}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{ fontWeight: "bold", textAlign: "right" }}
                          >
                            تێچووی خوێندن
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: "center",
                            }}
                          >
                            {parseFloat(tuition.tuition_fee).toLocaleString()}{" "}
                            دینار
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{ fontWeight: "bold", textAlign: "right" }}
                          >
                            داشکان
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: "center",
                            }}
                          >
                            {tuition.discount_type === "percentage"
                              ? `${tuition.discount_amount}%`
                              : `${parseFloat(
                                  tuition.discount_amount
                                ).toLocaleString()} دینار`}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{ fontWeight: "bold", textAlign: "right" }}
                          >
                            بڕی کۆتایی
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: "center",
                            }}
                          >
                            {parseFloat(tuition.final_amount).toLocaleString()}{" "}
                            دینار
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}

          {/* Payment History */}
          {studentData.tuition_payments?.length > 0 && (
            <Box
              sx={{
                p: 3,
                backgroundColor: "#f9f9f9",
                borderRadius: "6px",
                border: "1px solid #e0e0e0",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  mb: 2,
                  color: "#333",
                  fontWeight: "bold",
                  borderBottom: "1px solid #e0e0e0",
                  pb: 1,
                }}
              >
                مێژووی پارەدان
              </Typography>
              <TableContainer>
                <Table
                  sx={{
                    border: "1px solid #e0e0e0",
                    "& .MuiTableCell-root": {
                      border: "1px solid #e0e0e0",
                      padding: "8px 16px",
                    },
                  }}
                >
                  <TableBody>
                    <TableRow sx={{ backgroundColor: "#f0f0f0" }}>
                      <TableCell
                        sx={{ fontWeight: "bold", textAlign: "right" }}
                      >
                        بڕی پارەدراو
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", textAlign: "right" }}
                      >
                        بەرواری پارەدان
                      </TableCell>
                    </TableRow>
                    {studentData.tuition_payments.map((payment) => (
                      <TableRow key={payment.id}>
                        <TableCell
                          sx={{
                            textAlign: "right",
                          }}
                        >
                          {parseFloat(payment.amount_paid).toLocaleString()}{" "}
                          دینار
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "right",
                          }}
                        >
                          {payment.payment_date}
                        </TableCell>
                      </TableRow>
                    ))}
                    <TableRow sx={{ backgroundColor: "#f0f0f0" }}>
                      <TableCell
                        sx={{ fontWeight: "bold", textAlign: "right" }}
                      >
                        کۆی گشتی پارەدراو
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", textAlign: "right" }}
                      >
                        {totalPaid.toLocaleString()} دینار
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ backgroundColor: "#f0f0f0" }}>
                      <TableCell
                        sx={{ fontWeight: "bold", textAlign: "right" }}
                      >
                        بڕی پارەی نەدراوە
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", textAlign: "right" }}
                      >
                        {remainingAmount.toLocaleString()} دینار
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}

          {/* Footer */}
          <Box
            sx={{
              mt: 4,
              pt: 2,
              borderTop: "2px solid #f0f0f0",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography
                variant="body2"
                sx={{ fontStyle: "italic", color: "#777" }}
              >
                بەرواری چاپ: {new Date().toLocaleDateString()}
              </Typography>
            </Box>
            <Box sx={{ textAlign: "left" }}>
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                واژووی ژمێریار 
              </Typography>
              <Typography variant="body2" sx={{ mt: 2 }}>
                _______________________
              </Typography>
            </Box>
          </Box>
        </Paper>
      </div>

      <style>
        {`
        @media print {
  body * {
    visibility: hidden;
  }
  #delivery-note, #delivery-note * {
    visibility: visible;
  }
  #delivery-note {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    margin: 0;
    padding: 5mm; /* ↓ padding کەمترکرا */
    border: none;
    box-shadow: none;
  }
  button {
    display: none !important;
  }
  @page {
    size: A4;
    margin: 8mm; /* ↓ margin کەمترکرا */
  }
  body {
    background: white;
    font-size: 10pt; /* ↓ font-size کەمترکرا */
    line-height: 1.3; /* ↓ زۆری سپەیس کەم دەکات */
  }
  .MuiPaper-root {
    box-shadow: none !important;
    border: none !important;
    padding: 10px !important; /* ↓ paddingی paper کەمترکرا */
  }

  .MuiTableCell-root {
    padding: 2px 8px !important; /* ↓ paddingی خانەی خشتە کەمترکرا */
    font-size: 10pt !important;
  }

  h4, h6, p, span, td, th {
    font-size: 10pt !important;
  }
}

        `}
      </style>
    </Box>
  );
};

export default PrintStudent;
